import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Shell for pages merged by the Sep 2026 nav restructure: a tab strip of real
// links (?tab=) and ONLY the active tab's page mounted, so each legacy page
// behaves exactly as it did on its own route.
export default function MergedPage({ tabs, defaultTab, testId }) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const requested = params.get('tab');
  const active = tabs.find((t) => t.key === requested) || tabs.find((t) => t.key === defaultTab) || tabs[0];
  const href = (key) => { const p = new URLSearchParams(location.search); p.set('tab', key); return `${location.pathname}?${p.toString()}`; };
  return (
    <div data-testid={testId}>
      <div className="px-4 md:px-6 pt-4">
        <div className="inline-flex flex-wrap gap-1 p-1 rounded-xl" style={{ background: '#1A2433', border: '1px solid #2D3748' }} role="tablist" data-testid={`${testId}-tabs`}>
          {tabs.map((t) => {
            const on = t.key === active.key;
            return (
              <Link key={t.key} to={href(t.key)} role="tab" aria-selected={on} data-testid={`${testId}-tab-${t.key}`}
                className={`px-3.5 py-1.5 rounded-lg text-sm font-medium transition-colors ${on ? 'text-white shadow' : 'text-slate-400 hover:text-white hover:bg-white/5'}`}
                style={on ? { background: '#1E88E5' } : undefined}>
                {t.label}
              </Link>
            );
          })}
        </div>
      </div>
      <div data-testid={`${testId}-panel-${active.key}`}>{active.render()}</div>
    </div>
  );
}
